<script>
  import { push } from 'svelte-spa-router'; // Import the push function

  export let icon;
  export let label;
  export let link = '#'; // This will be the route for navigation
  export let cl = '';

  // Function to handle navigation using svelte-spa-router
  function navigate(event) {
      event.preventDefault(); // Prevent the default href behavior
      push(link); // Use svelte-spa-router's push function to navigate
  }
</script>

<a href={link} class={cl} on:click={navigate}> <!-- Keep href for a11y but use push for SPA routing -->
  {#if icon && icon.startsWith('fa-')}
    <i class={"icon " + icon}></i>
  {:else if icon}
    <img src={icon} alt="" class="icon" />
  {/if}
  <span>{label}</span>
</a>

  
  <style>
    a {
      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 15px 20px;
      width: 100%;
      min-height: 60px;
      position: relative; /* For absolute positioning of text */
      
      /* Keep the same color scheme */
      background: #fab45a;
      
      /* Remove black border for modern look */
      border: none;
      
      /* Modern subtle shadow */
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
      
      border-radius: 8px;
      cursor: pointer;
      text-decoration: none;
      
      /* Smooth transitions */
      transition: all 0.3s ease;
      
      /* Modern button styling */
      outline: none;
      flex: none;
      order: 0;
      align-self: stretch;
      flex-grow: 0;
    }
    
    a:hover {
      background-color: #927043;
      transform: translateY(-2px);
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
    }
    
    a:focus {
      outline: 2px solid #fab45a;
      outline-offset: 2px;
    }
  
    .icon {
      width: 24px; /* Icon size */
      height: 24px;
      font-size: 1.5rem; /* Smaller, more modern icon size */
      display: flex;
      align-items: center;
      justify-content: center;
      color: #333; /* Darker color for better contrast */
      position: absolute; /* Position absolutely */
      left: 20px; /* Left padding distance */
      flex-shrink: 0;
    }
  
    span {
      font-size: 1rem;
      font-weight: 600; /* Slightly less bold for modern look */
      color: #333;
      text-align: center;
      width: 100%; /* Take full width */
      position: absolute; /* Position absolutely for perfect centering */
      left: 0;
      right: 0;
    }
  </style>
  